/**
 * 首页输入框
 */

import { useEffect, useMemo, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { MESSAGE_MAX_LENGTH } from '@/shared/chat';
import EE from '@/common/event';
import { Divider } from 'antd';
import Microphone from '@/components/microphone';
import ChatEditor from '@/components/chat/ChatEditor';
import SendButton from '@/components/chat/SendButton';
import { observer } from 'mobx-react-lite';
import modelChoiceStore from '@/components/model-choice/store';
import fieldCategoryStore from '@/components/field-category/store';
import chatStoreManager from '@/store/chat/manager';
import userStore from '@/store/user';
import navbarStore from '@/store/navbar';
import appLogger from '@public/log/monitor';
import UploadButton from '../UploadButton';
import inputTypeStore from '@/components/input-file/input-type';
import { HelperCore, HelpOther } from '@/common/helper';
import Conf from '@/common/conf';
import globalStore from '@/store/global';
import client from '@/store/client';
import ServerChoice from '@/components/server-choice';
import ChatMultiFile from '../ChatMultiFile';
import chatInputStore from './store';
import ScreenShot from '../ScreenShot';
import FoldSwitch from '@/ui/fold-switch';
import { newSearch } from '@src/pages/search';
import { getAgentFlowId, isAgentFlowId, McpAgentType } from '@shared/constants/mcp';
import Tooltip from '@/ui/tooltip';
import useFilePaste from './file-paste';
import { ACCEPT_MEDIA_TYPE, FILE_TYPE } from '@/components/input-file/shared';
import NewSwitch from '../NewSwitchDeep';
import { isNil } from 'lodash-es';
import Loader from '@/common/helper/loader';
import genFileTypesStore from '@/pages/search-home/components/gen-file-types/store';
import homeSimpleAgentsStore from '@/pages/search-home/components/simple-agents/store';
import urlStore from '@/store/chat/urlStore';
import AgentLimit from '@/components/agent-limit';
import GaokaoxkStore from './Gaokaoxk/GaokaoxkStore';
import homeStore from '@/pages/search-home/store';
import { dentifyIntent } from '@/common/fetch-event-source';
import { SVGPureIcon } from '@/ui';
import aiSoHomeStore from '@/pages/search-home/store';

function ChatInput(props) {
  const store = chatInputStore;
  /*
  home：首页
  create: 创建会话弹窗
  */
  const {
    scene,
    sug,
    sugStore,
    classname = [],
    placeholder,
    agentInfo /** 智能体详情传入数据 */,
    handleSendAgent /** 用于Ai智能体发送消息 */,
    isPromptTyping /** 提示词表单 */,
    style = {},
    showToolbars = true
  } = props;

  // 大模型首页
  const isHome = scene == 'home';
  // 智能体
  const isAiAgent = agentInfo ? true : false;
  // AI 搜索首页
  const isAiso = scene == 'aiso';
  // 智能体首页
  const isSquare = scene == 'square';
  // 首页推荐智能体
  const recommendAgent = scene === 'recommendAgent';
  // 对话框前展示的agent
  const agentSayRef = useRef(null);
  // 是否工作流智能体
  const isAgentFlow = isAiAgent && isAgentFlowId(getAgentFlowId(agentInfo));

  const query = HelperCore.getQueryString('query');

  // 监听是否输入状态
  const [isComposition, setIsComposition] = useState(null);
  const [isSending, setIsSending] = useState(false);

  // 计算agentSayRef的宽度，用于textarea缩进
  const [textIndent, setTextIndent] = useState(0);
  const [recommendAgentOptions, setRecommendAgentOptions] = useState({});
  useEffect(() => {
    const el = agentSayRef.current;
    if (recommendAgent && el) {
      setTextIndent(el.offsetWidth + 5);
    }

    setTimeout(() => {
      const el = agentSayRef.current;
      if (recommendAgent && el) {
        setTextIndent(el.offsetWidth + 5);
      }
    }, 100);

    let input_func = agentInfo?.input_func || '1';
    input_func = input_func.split(',');

    setRecommendAgentOptions({
      enableInput: input_func.indexOf('1') > -1 ? true : false, // 能否输入
      enableUploadImg: input_func.indexOf('3') > -1 ? true : false, // 能否上传图片
      enableUploadFile: input_func.indexOf('2') > -1 ? true : false, // 能否上传文件
      enableUploadLink: input_func.indexOf('4') > -1 ? true : false, // 能否上传链接
    });
  }, [recommendAgent, agentInfo]);

  const disabled = useMemo(() => {
    return props.disabled
  }, [props.disabled]);

  const btnDisabled = useMemo(() => {
    if (recommendAgent) {
      const { enableInput, enableUploadImg, enableUploadFile } = recommendAgentOptions;

      // 禁止输入，只允许上传图片、文件时
      if (
        !enableInput &&
        (enableUploadImg || enableUploadFile) &&
        inputTypeStore?.tempFile?.length > 0 &&
        !inputTypeStore.sendDisabled
      ) {
        return false;
      }
    }

    return (
      (disabled &&
        !(agentInfo && agentInfo.doc_def_prompt && inputTypeStore.tempFile) &&
        !isPromptTyping) ||
      inputTypeStore.sendDisabled
    );
  }, [
    disabled,
    agentInfo,
    isPromptTyping,
    inputTypeStore?.tempFile,
    inputTypeStore?.sendDisabled,
    recommendAgentOptions,
    GaokaoxkStore.requiredFields,
  ]);

  const maxLength = useMemo(() => {
    if (globalStore.globalConfig.donotLimitInput) {
      return;
    }

    let maxLength = navbarStore.chatModels[modelChoiceStore.curId]?.input_length;
    maxLength = maxLength > 0 ? maxLength : MESSAGE_MAX_LENGTH;
    return maxLength;
  }, [modelChoiceStore.curId]);

  const handleSend = async (prompt, type, detail) => {
    console.info('>>>_send', prompt, type, detail);
    if (btnDisabled && !prompt) {
      return;
    }
    setIsSending(true); // 设置为正在发送状态
    let selectedFieldCategory = fieldCategoryStore.getCheckedCategory();
    let intentRes;
    if (isAiso && !globalStore.is_super_aiso && !homeSimpleAgentsStore.currentId) {
      // 走 AI 搜索
      const fileParams = inputTypeStore.getSendParams();
      const params = {
        prompt: prompt || store.content.trim() || agentInfo?.doc_def_prompt || '',
      };
      // 单图，走图搜
      if (fileParams.file?.length == 1 && fileParams.file[0].file_type == FILE_TYPE.image) {
        params.image_url = fileParams.file[0].url;
      }
      // 多文件，走 chat_doc
      else {
        Object.assign(params, fileParams);
      }
      homeStore.setData('showSearching', params.prompt);
      intentRes = await dentifyIntent({
        question: params.prompt,
        category: selectedFieldCategory || 'auto',
        aiso: 1,
      });
      if (intentRes.code == 1) {
        setTimeout(() => {
          homeStore.setData('showSearching', false);
        }, 150);
        newSearch(params);
        store.setContent('');
        clearSug();
        return;
      }
    }
    //高考填志愿临时解决方案
    const GAOKAO_AGENT_ID = 'edd495e32d774844b9bf9b0dd02d2bac';
    if (intentRes && intentRes.agentId == GAOKAO_AGENT_ID) {
      if (client.isLLQ) {
        HelpOther.toast('已为您切换到高考智能体！填写信息，AI 帮您精准推荐～', 'info');
      }
      homeStore.setData('showSearching', false);
      globalStore.navigate(`/tools/aiagent/chat/${GAOKAO_AGENT_ID}`);
      return;
    }
    //只有AI搜索首页才会传领域的category值
    if (!isAiso) {
      selectedFieldCategory = '';
    }

    const params = {
      asstId: modelChoiceStore.curId,
      input: prompt || store.content.trim() || agentInfo?.doc_def_prompt || '',
      fileType: type,
      file: detail,
      field_category: selectedFieldCategory, // 领域分类, 走超级搜索
      intentRes,
      kwargs: {
        specify_gen_file_type:
          isAiso && globalStore.is_super_aiso && selectedFieldCategory == 'auto'
            ? HelperCore.copyObj(genFileTypesStore.checkedList)
            : [],
      },
    };
    if (params.field_category == 'auto' && params.kwargs.specify_gen_file_type.length) {
      if (params.kwargs.specify_gen_file_type.includes('video')) {
        params.field_category = 'video';
        params.kwargs.specify_gen_file_type = [];
      } else if (params.kwargs.specify_gen_file_type.includes('image')) {
        params.field_category = 'image';
        params.kwargs.specify_gen_file_type = [];
      }
    }

    if (homeSimpleAgentsStore.currentId) {
      params.field_category = '';
      params.kwargs.specify_gen_file_type = [];
      const { input, ...others } = params;
      urlStore.newAiAgentChat(homeSimpleAgentsStore.currentId, params.input, {
        from_aiso: 1,
        ...others,
      });
      return;
    }

    // 因为要走智能体，所以不能有模型id
    if (selectedFieldCategory) {
      params.asstId = '';
    }

    // 如果走智能体流程
    if (isAiAgent) {
      handleSendAgent && handleSendAgent(params);
      return;
    }
    chatStoreManager.newChat(params);
    store.setContent('');
    clearSug();

    chatStoreManager.setNewChatLogData({
      key: appLogger.getRouterName(),
      input_type: 'text_inout', // 文字输入
    });
  };

  const isShowSo = useMemo(() => {
    if (isAiAgent || recommendAgent) {
      return false;
    }
    if (isAiso) {
      return false;
    }
    if (isSquare) {
      return false;
    }

    return globalStore.getRobotOnlineSet(modelChoiceStore.curId);
  }, [modelChoiceStore.curId, navbarStore.chatModels, isAiAgent, isAiso, scene]);
  const isShowDeep = useMemo(() => {
    return globalStore.getRobotDeepSet(modelChoiceStore.curId);
  }, [modelChoiceStore.curId, navbarStore.chatModels]);

  const { pasteFiles, setPasteFiles, handlePasteChange } = useFilePaste();
  useEffect(() => {
    if (!pasteFiles.length) return;
    if (isShowSo && globalStore.is_so) {
      HelpOther.toast(`联网搜索不支持上传图片`, 'info');
      setPasteFiles([]);
      return;
    }
    inputTypeStore.updateTempData('tempFile', pasteFiles);
    setPasteFiles([]);
  }, [pasteFiles, isShowSo, globalStore.is_so]);

  useEffect(() => {
    globalStore.robotOnlineSo(modelChoiceStore.curId);
    globalStore.robotDeepSo(modelChoiceStore.curId);
    globalStore.robotDynamicPageSo(modelChoiceStore.curId);
  }, [modelChoiceStore.curId]);

  useEffect(() => {
    if (sug?.name) {
      store.setContent(sug.name);
    }
  }, [sug]);

  // 路由变更后清空输入框的内容(仅智能体中间页有此功能)
  const location = useLocation();
  useEffect(() => {
    store.setContent('');
    clearSug();
    fieldCategoryStore.reset();
    genFileTypesStore.reset();
    setIsSending(false);

    homeSimpleAgentsStore.reset();
  }, [location.pathname]);

  useEffect(() => {
    if (query) {
      store.setContent(query);
    }
  }, [query]);

  useEffect(() => {
    EE.on('send_message', handleSend);
    EE.on('send_message_sucess', clearStatus);
    return () => {
      EE.off('send_message', handleSend);
      EE.off('send_message_sucess', clearStatus);
    };
  }, []);

  const clearSug = () => {
    if (sugStore?.curSugInfo?.category) {
      sugStore.setData('curSugInfo', {});
    }
  };

  // 清空输入框
  const clearStatus = () => {
    store.setContent('');
    clearSug();
  };

  const handleAiso = index => {
    fieldCategoryStore.switchSuperSo(index == 0 ? false : true);
    // 如果切换到AI搜索
    if (index == 0) {
      fieldCategoryStore.reset();
      genFileTypesStore.reset();
      // 去掉音视频
      if (inputTypeStore.tempFile?.length > 0) {
        const tempFile = Array.from(inputTypeStore.tempFile || []);
        let filteredTempFile = tempFile.filter(file => {
          try {
            const ext = `.${HelperCore.getFileNameExt(file.name)}`.toLowerCase();
            return !ACCEPT_MEDIA_TYPE.includes(ext);
          } catch (e) {}
          return true;
        });
        if (filteredTempFile.length != tempFile.length) {
          // message.info("AI 搜索暂不支持音视频");
          inputTypeStore.reset();
          inputTypeStore.updateTempData('tempFile', filteredTempFile);
        }
      }
    } else {
      homeSimpleAgentsStore.reset();
    }
  };

  const handleSo = () => {
    globalStore.robotOnlineSo(modelChoiceStore.curId, !globalStore.is_so);

    if (globalStore.is_so) {
      inputTypeStore.reset();
    }
  };

  const handleDeep = () => {
    globalStore.robotDeepSo(modelChoiceStore.curId, !globalStore.is_deep[modelChoiceStore.curId]);
  };

  const handleDyPage = () => {
    globalStore.robotDynamicPageSo(modelChoiceStore.curId, !globalStore.is_dy_page);
    appLogger.log({
      key: appLogger.getRouterName(),
      action: 'click',
      arrt: 'so_page',
    });
  };

  const showUpload = useMemo(() => {
    if (isAgentFlow && !globalStore.globalConfig.supportKnowledgeWithFlow) {
      return false;
    }
    if (agentInfo) {
      if (recommendAgent) {
        return false;
      }

      // 智能体都支持
      if (globalStore.globalConfig.supportUploadFileWithAllAgent) {
        return true;
      }

      // 仅简版智能体支持
      if (agentInfo.agent_type != McpAgentType.normal) {
        return true;
      } else {
        return false;
      }
    }
    return (
      (modelChoiceStore.curId == Conf.roleIds.assistant || inputTypeStore.supportUploadFile) &&
      navbarStore.chatModels[modelChoiceStore.curId]?.conversation_type != 1 &&
      !navbarStore.chatModels[modelChoiceStore.curId]?.localModel
    );
  }, [modelChoiceStore.curId, agentInfo, isAgentFlow, inputTypeStore.supportUploadFile]);

  const enableServerChoice = useMemo(() => {
    try {
      const list = globalStore.cloudConfig?.assistantLlmMcp?.roleids?.split(',');
      return list.includes(modelChoiceStore.curId);
    } catch (e) {}
    return false;
  }, [modelChoiceStore.curId, navbarStore.chatModels]);

  return (
    <div
      id="NM-ASSISTANT_chat_input" /** 0418用于定位prompt表单 */
      style={{
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.12), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)',
        // 位置相对定位，确保z-index生效, 保证领域分类在输入框下面
        position: 'relative',
        zIndex: 100,
        ...style,
      }}
      className={[
        'p-12px px-16px border border-black',
        isAiAgent && !isSquare ? 'border-opacity-16' : '',
        'bg-input-bg-normal rounded-12px pointer-events-auto',
        isPromptTyping ? 'rounded-tl-none rounded-tr-none' : '',
        ...classname,
      ]}
    >
      <section
        className={[
          'pr-8px',
          isAiso || isSquare || isHome ? 'pb-24px' : isAiAgent ? 'pb-12px' : 'pb-12px',
        ]}
      >
        {inputTypeStore.tempFile &&
          (modelChoiceStore.curId == Conf.roleIds.assistant ||
            inputTypeStore.supportUploadFile) && (
            <ChatMultiFile
              handleSend={handleSend}
              supportKnowledge={/** 仅普通AI搜索提供 */ isAiso && !globalStore.is_super_aiso}
            />
          )}

        {recommendAgent ? (
          <div
            className="size-48px absolute right-0px top-0px z-2 cursor-pointer bg-white rounded-12px"
            onClick={() => {
              aiSoHomeStore.closeCustomInputPage();
            }}
          >
            <SVGPureIcon name="input_clear" className="size-48px hover:text-[#000000]" />
          </div>
        ) : null}

        <div className="relative">
          {recommendAgent ? (
            <>
              <div
                ref={agentSayRef}
                className="h-30px flex items-center absolute left-0px top-0px bg-white z-2"
              >
                <img src={agentInfo.icon} className="size-20px rounded-full mr-6px"></img>
                <span className="text-16px font-bold text-[#006AFF]">{agentInfo.title}：</span>
              </div>
            </>
          ) : null}

          <ChatEditor
            scene={'home'}
            className={[recommendAgent ? '!p-0 !pt-3px !pr-20px' : '!p-0']}
            style={{ textIndent: textIndent }}
            maxLength={maxLength}
            autoSize={{ minRows: isAiAgent && !isSquare && !recommendAgent ? 1 : 2, maxRows: 16 }}
            value={store.content}
            placeholder={placeholder}
            disabledInput={disabled || (recommendAgent && !recommendAgentOptions.enableInput) ? true : false}
            onChange={content => {
              store.setContent(content);
              clearSug();
            }}
            handlePaste={event => {
              const isSuperSo = isNil(globalStore.is_super_aiso)
                ? globalStore.is_aiso
                : globalStore.is_super_aiso;
              if (globalStore.isAiso() && !isSuperSo) {
                return handlePasteChange(event, 1);
              }
              handlePasteChange(event);
            }}
            onPressEnter={() => {
              handleSend();
            }}
          />
        </div>
      </section>

      {showToolbars && (
        <section className={['flex items-end', 'justify-between', 'h-36px']}>
          <div className="flex items-center gap-8px">
            {Loader.isDynamicPageRole(modelChoiceStore.curId) && !isAiAgent && !isAiso ? (
              <FoldSwitch
                onClick={handleDyPage}
                text="AI动态网页"
                iconName="dy_page"
                small={false}
                circle
                checked={globalStore.is_dy_page}
              />
            ) : null}

            {isShowDeep && !isAiAgent && !isAiso ? (
              <FoldSwitch
                onClick={handleDeep}
                text="深度"
                iconName="deepseek"
                small={false}
                circle
                checked={globalStore.is_deep[modelChoiceStore.curId]}
              />
            ) : null}

            {isShowSo && !isAiAgent && !isAiso ? (
              <FoldSwitch
                onClick={handleSo}
                text="联网"
                iconName="net"
                small={false}
                circle
                checked={globalStore.is_so}
              />
            ) : null}

            {!isSquare && isAiAgent && !recommendAgent ? (
              <AgentLimit
                pos={isAiAgent ? 'aiagent' : isSquare ? 'aisquare' : ''}
                isLimitedAgent={globalStore?.isLimitedAgent(agentInfo?.id)}
              />
            ) : null}

            {
              //首页推荐智能体
              recommendAgent || isAiAgent ? (
                <div>
                  <UploadButton
                    recommendAgent={true}
                    recommendAgentOptions={recommendAgentOptions}
                  />
                </div>
              ) : null
            }

            {userStore.isReady &&
            !isAiAgent &&
            client.supportMcpAgent &&
            enableServerChoice &&
            !isAiso ? (
              <ServerChoice scene={'home'} />
            ) : null}
            {isAiso ? (
              <NewSwitch
                onClick={handleAiso}
                checked={globalStore.is_super_aiso}
                isComposition={isComposition}
              />
            ) : null}
          </div>

          <div className="flex items-center gap-[4px]">
            {showUpload &&
            (isAiso ||
              isSquare ||
              (isAiAgent &&
                [McpAgentType.normal, McpAgentType.simple].includes(agentInfo.agent_type)) ||
              globalStore.globalConfig.supportModelWithMultiKnowledge) &&
            globalStore.globalConfig.supportNewFileInput &&
            !(isAgentFlow && !globalStore.globalConfig.supportKnowledgeWithFlow) ? (
              <UploadButton
                isShowSo={isShowSo}
                onlyKnowledge
                supportKnowledge
                simple
              />
            ) : null}
            {
              // 仅客户端可截图
              globalStore.cloudConfig.webConfig?.support_screen_shot == 1 &&
              client.supportScreenShot &&
              globalStore.globalConfig.supportNewFileInput &&
              !(isAgentFlow && !globalStore.globalConfig.supportKnowledgeWithFlow) &&
              !recommendAgent ? (
                <ScreenShot className="" isShowSo={isShowSo} />
              ) : null
            }
            {showUpload ? (
              (isAiso || isHome || isAiAgent || isSquare) &&
              globalStore.globalConfig.supportNewFileInput ? (
                <>
                  <UploadButton
                    isShowSo={isShowSo}
                    singleImage
                    agentInfo={agentInfo}
                    supportKnowledge={true}
                    simple
                  />
                  <UploadButton
                    isShowSo={isShowSo}
                    multiFile
                    supportKnowledge={true}
                    simple
                    agentInfo={agentInfo}
                    notMedias={
                      (isAiso && !globalStore.is_super_aiso) ||
                      isHome ||
                      (isAiAgent &&
                        ![McpAgentType.normal, McpAgentType.simple].includes(agentInfo.agent_type))
                    }
                    className="upload-multi-file"
                  />
                </>
              ) : (
                <UploadButton
                  isShowSo={isShowSo}
                  supportKnowledge={
                    isAiAgent &&
                    [McpAgentType.normal, McpAgentType.simple].includes(agentInfo.agent_type)
                  }
                  simple
                />
              )
            ) : null}
            <Microphone
              onChange={content => {
                store.appendContent(content);
                EE.emit('chat_input_focus');
              }}
              scene={scene}
            />
            <Divider
              className={`!mr-[12px] ${!client.supportMic ? 'hidden-in-client' : ''}`}
              type="vertical"
            />
            <Tooltip placement="bottom">
              <SendButton
                disabled={btnDisabled || isSending} // 提示词表单打开，允许发送
                onClick={() => {
                  handleSend();
                }}
                className="flex-shrink-0 size-32px flex justify-center items-center"
              />
            </Tooltip>
          </div>
        </section>
      )}
    </div>
  );
}

export default observer(ChatInput);
